// removed by extract-text-webpack-plugin
module.exports = {"link":"_2LuKFNlvoIsXOK9ZyW0hdF","listImg":"_1btB2LZ_pVb5hV4N2RuBQP","content":"_2SAFzZRtKsPlhrlVSuOf5z","tags":"_1y10xNrYbSAvaWNVBO5cJ_","name":"_1pgVXu3kgBO11-Wa0gEiZi","engName":"_1w90d5efYC3CXr_ki8lBRB","chtName":"KYUprykgAmliveHf4UHyd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/content-related-project/ContentRelatedProject.css
// module id = 386
// module chunks = 0